import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=b81881ae&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=js&"
export * from "./Wizard.vue?vue&type=script&lang=js&"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=b81881ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81881ae",
  null
  
)

export default component.exports